import types from '../actions/types';

const reloadOnImpersonationMiddleware = store => next => action => {
  const prevUser = store.getState().session.user;

  const result = next(action);

  if (
    action.type === types.FETCH_CURRENT_USER_SUCCESS &&
    action.response &&
    action.response.data
  ) {
    const nextUser = action.response.data;

    const userChanged =
      prevUser.id !== nextUser.id ||
      prevUser.accessProfile !== nextUser.accessProfile;

    if (userChanged) {
      window.location.reload();
    }
  }

  return result;
};

export default reloadOnImpersonationMiddleware;
